import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, counter, moamad }) {
  const [newCrs, setNewCrs] = useState({
    title: "",
    length: "",
    start_date: null,
    end_date: null,
    education_frame: "",
    certifcate: "",
    moamad: moamad.id,
  });
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewCrs((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.post(baseURL + "course/", newCrs, {
          signal: controller.signal,
        });
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  // render
  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3>
              קורסים והשתלמיות של המועמד: {moamad.f_name} {moamad.father_name}{" "}
              {moamad.l_name}
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="title">שם הקורס/השתלמות </label>
                    <input
                      type="text"
                      name="title"
                      className="form-control"
                      id="title"
                      value={newCrs.title}
                      placeholder="תקליד שם קורס להוספה"
                      onChange={handleChange}
                    />
                  </div>
                  <br></br>
                  <Row>
                    <Col>
                      <div className="form-cgroup">
                        <label htmlFor="length">משך הקורס</label>
                        <input
                          type="text"
                          name="length"
                          className="form-control"
                          id="length"
                          value={newCrs.length}
                          placeholder="כמו 3 חודשים"
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="start_date">תקופה מ-</label>
                        <input
                          type="date"
                          name="start_date"
                          className="form-control"
                          id="start_date"
                          value={newCrs.start_date}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="subject">תקופה עד-</label>
                        <input
                          type="date"
                          name="end_date"
                          className="form-control"
                          id="end_date"
                          value={newCrs.end_date}
                          placeholder=""
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <br></br>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="education_frame">מסגרת לימודים</label>
                        <input
                          type="text"
                          name="education_frame"
                          className="form-control"
                          id="education_frame"
                          value={newCrs.education_frame}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="certifcate">תעודת גמר</label>
                        <input
                          type="text"
                          name="certifcate"
                          className="form-control"
                          id="certifcate"
                          value={newCrs.certifcate}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>

                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </div>
  );
}
